export default {
	"fca1": "Các bước mở tài khoản thanh toán thanh khoán FCA",
	"fca1-m": "Các bước mở tài khoản thanh toán thanh khoán FCA",
	"fca2": "EBC Financial Group (UK) Ltd được ủy quyền và quản lý bởi Cơ quan Quản lý Tài Chính (FCA). Tất cả các lệnh giao dịch được chuyển trực tiếp tới nhóm thanh toán quốc tế. Số giấy phép: 927552<br><br>Mở tài khoản thanh toán thanh khoản FCA tại EBC Financial Group (UK) Ltd cho phép bạn có thể yêu cầu bồi thường lến đến 85.000£ theo Điều khoản bồi thường FSCS.",
	"fca3": "Định hướng Công cụ Tài chính thị trường (MiFID) của liên minh Châu Âu và các bản sửa đổi tiếp theo MiFID II, phân loại các nhà đầu tư thành \"nhà đầu tư nhỏ lẻ\" hoặc \"nhà đầu tư chuyên nghiệp\" theo kiến thức, kinh nghiệm và chuyên môn của họ.<br><br>Theo quy định của FCA, EEBC Financial Group (UK) Ltd chỉ chấp nhận các nhà đầu tư chuyên nghiệp và nhà đầu tư tổ chức, đồng thời có thể mở tài khoản thanh toán thanh khoản FCA với đòn bẩy gấp 100. Tiền của nhà đầu tư sẽ được lưu trữ độc lập trong tài khoản tách biệt của Ngân hàng Barclays.",
    "fca4":{
		"title":"Nhà đầu tư chuyên nghiệp phải đáp ứng được 2 trong 3 yêu cầu dưới đây:",
		"title-m":"Nhà đầu tư chuyên nghiệp phải đáp ứng được 2 trong 3 yêu cầu dưới đây:",
		"desc":"Tần xuất giao dịch trung bình trong năm đạt mốc 10 lần/quý",
		"desc1":"Nắm giữ hạng mục đầu tư hơn 500.000 EUR, bao gồm tiết kiệm tiền mặt và công cụ tài chính",
		"desc2":"Có ít nhất 1 năm kinh nghiệm làm việc trong ngành tài chính, hiểu về CFD hoặc giao dịch phái sinh."
	},
	"fca5":{
		"title":"Các bước mở tài khoản thanh toán thanh khoán FCA",
		"desc":"Tải mẫu đơn xin và điền đầy đủ",
		"desc1":"Chuẩn bị tài liệu và chứng thực",
		"desc2":"Gửi tài liệu và đăng ký mail",
		"desc3":"Phê duyệt hợp quy và ký kết tài liệu",
		"desc4":"Mở và cài đặt thành công tài khoản FCA",
		"btn":"Tải mẫu đơn đăng ký nhà đầu tư chuyên nghiệp",
		"btn1":"Tải mẫu đơn đăng ký nhà đầu tư tổ chức"
	},
	"fca6":{
		"title":"Mở tài khoản thanh toán thanh khoản FCA Bảo vệ theo quy định có thẩm quyền nhất và đảm bảo tài chính an toàn nhất",
		"title-m":"Mở tài khoản thanh toán thanh khoản FCA Bảo vệ theo quy định có thẩm quyền nhất và đảm bảo tài chính an toàn nhất",
		"desc":"Cơ quan Quản lý Tài Chính (FCA)",
		"desc1":"email: ",
		"desc2":""
	},
	"lang":"en",
	FCA流动性清算账户开设流程: `Các bước mở tài khoản thanh khoản FCA`,
	"EBC Financial Group Limited是受英国金融市场行为管理局（FCA）授权并监管的综合金融券商":
	  "EBC Financial Group Limited (Anh) được cấp phép và quản lý bởi Cơ quan Quản lý Tài Chính (FCA). Tất cả các lệnh giao dịch được chuyển trực tiếp tới nhóm thanh toán quốc tế. Số giấy phép: 927552",
	"在EBC Financial Group Limited开设FCA流动性清算账户":
	  "Khách hàng có tài khoản tại EBC Financial Group (UK) Ltd có quyền yêu cầu bồi thường lên đến 85.000 GBP theo chương trình bồi thường FSCS.",
	"欧盟《金融工具市场法规（MiFID）》及其后修订版MiFID": `Định hướng Công cụ Tài chính thị trường (MiFID) của liên minh Châu Âu và các bản sửa đổi tiếp theo MiFID II, phân loại các nhà đầu tư thành "nhà đầu tư nhỏ lẻ" hoặc "nhà đầu tư chuyên nghiệp" theo kiến thức, kinh nghiệm và chuyên môn của họ.`,
	根据FCA法规: `Theo quy định của FCA, EBC Financial Group Limited chỉ chấp nhận các nhà đầu tư chuyên nghiệp và nhà đầu tư tổ chức, đồng thời có thể mở tài khoản thanh toán thanh khoản FCA với đòn bẩy gấp 100. Tiền của nhà đầu tư sẽ được lưu trữ độc lập trong tài khoản tách biệt của Ngân hàng Barclays.`,
	专业投资者须满足以下三个标准中的其中两个: `Nhà đầu tư chuyên nghiệp phải đáp ứng được 2 trong 3 yêu cầu dưới đây:`,
	"过去一年平均交易频率达到10次/季度": "Tần xuất giao dịch trung bình trong năm đạt mốc 10 lần/quý",
	持有超过50万欧元的投资组合:
	  "Nắm giữ hạng mục đầu tư hơn 500.000 EUR, bao gồm tiết kiệm tiền mặt và công cụ tài chính",
	在金融行业工作或至少工作过一年:
	  "Có ít nhất 1 năm kinh nghiệm làm việc trong ngành tài chính, hiểu về CFD hoặc giao dịch phái sinh.",
	FCA流动性清算账户开户流程: `Các bước mở tài khoản thanh khoản FCA`,
	获取申请表: "Nhập Mẫu Đơn",
	访EBC英国站: "Truy cập trang web EBC UK để lấy mẫu đơn.",
	提交材料: "Gửi Hồ Sơ KYC",
	按要求填写: "Điền thông tin vào mẫu đơn và tải lên tài liệu KYC.",
	合规审核: "Đợi xét duyệt hồ sơ",
	等待合规审核: "Chờ bộ phận kiểm duyệt hồ sơ, sau đó ký các tài liệu liên quan.",
	开户成功: "Tạo Tài Khoản Thành Công",
	登录并设置您的FCA账户: "Đăng nhập và thiết lập tài khoản của bạn.",
	最权威的监管保护和最安全的: `Mở tài khoản được FCA quản lý với EBC Financial Group (UK) Ltd và tận hưởng sự an tâm với quy định hàng đầu và bảo mật quỹ.`,
	"英国金融市场行为管理局（FCA）": "Cơ quan Quản lý Tài Chính (FCA)",
	FCA流动性清算账户咨询邮箱: `Email:
					  <a href="mailto:support@ebcfin.co.uk">support@ebcfin.co.uk</a>`,
}

